import api from "./api"
import { getStoredShipper } from "../constants/utils"
const CAR_ORDER_PATTERNS = "ListCarOrderPatterns"
const CAR_ORDER_ROOT = ""
const SHIPPER_TRACKS_ROOT = "api/ListShipperTracks"
const SHIPPER_CAR_ORDER_SAVE = "api/CreateCarOrder"

const carorderApi = {
    getAllCarOrderData({ filter }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${CAR_ORDER_ROOT}ListCarOrders`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Filter: filter,
            },
            "CAR_ORDER"
        )
    },

    getShipperTracks() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${SHIPPER_TRACKS_ROOT}`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
            },
            "STAGING"
        )
    },

    saveCarOrderQuality(orderDetails, Emails) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()
        let params = {
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
            NewCarOrderParameters: orderDetails,
        }

        if (Emails && Emails.length)
            params["NotificationEmailAddresses"] = [...Emails]
        return api.post(`${SHIPPER_CAR_ORDER_SAVE}`, params, "STAGING")
    },

    getAllCarOrderPatternsData() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${CAR_ORDER_PATTERNS}`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
            },
            "CAR_ORDER"
        )
    },
}

export default carorderApi
